// extracted by mini-css-extract-plugin
module.exports = {"status":"TransferStatus_status__2UIMZ","statusInfoPlate":"TransferStatus_statusInfoPlate__2Uakx"};